import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { joinCss } from "./helpers/utils";

import appClasses from "./App.module.scss";
import classes from "./Footer.module.scss";

class Footer extends Component {
  render() {
    return (
      <Container className={appClasses.bodyContainer}>
        <Row className={joinCss("mx-0", appClasses["vertical-center-parent"])}>
          <Col
            className={joinCss(appClasses["center-div"], classes.footerTextDiv)}
          >
            <span className={classes.footerText}>
              המפרט הכללי לעבודות בנייה (הספר הכחול) שבהוצאת הוועדה הבין משרדית
              לסטנדרטיזציה של מסמכי החוזה ולמיחשובם.
              <br /> © כל הזכויות שמורות
            </span>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Footer;
